var portfolioEvaluationChart = {
	"3m": "3M",
	"1y": "1Y",
	"1stTrade": "Since 1st Trade",
	rangeDescription: "Range {start} to {end}"
};
var en = {
	portfolioEvaluationChart: portfolioEvaluationChart
};

export { en as default, portfolioEvaluationChart };
